/* resetter-offers.js - behaviour for the snippet cova-offers (bundle selector + add to cart).
   Picking an offer card updates: the selected styling, the "Good choice!" card, the variant id
   (and selling plan) that is posted, and the price shown in the add-to-cart button.
   The form posts to /cart/add with return_to=/checkout, so there is no cart step.
   The arrival date ("October 16th") is computed here from today + data-cova-ship-days. */
(function () {
  'use strict';
  if (window.CovaOffers) return;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function ordinal(n) {
    var r = n % 100;
    if (r >= 11 && r <= 13) return n + 'th';
    switch (n % 10) {
      case 1:
        return n + 'st';
      case 2:
        return n + 'nd';
      case 3:
        return n + 'rd';
      default:
        return n + 'th';
    }
  }
  function formatDate(d) {
    return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
  }
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initOffers(root) {
    if (root.dataset.covaOffersInit) return;
    root.dataset.covaOffersInit = '1';

    var radios = $$('.cova-offers__radio', root);
    var cards = radios.map(function (r) {
      return r.closest('.cova-offers__card');
    });
    var choices = $$('[data-cova-offer-choice]', root);
    var form = $('form', root);
    var idInput = $('[data-cova-offers-id]', root);
    var planInput = $('[data-cova-offers-plan]', root);
    var cta = $('[data-cova-offers-cta]', root);
    var ctaLabel = $('[data-cova-cta-label]', root);
    var ctaPrices = $('[data-cova-cta-prices]', root);
    var ctaTotal = $('[data-cova-cta-total]', root);
    var ctaCompare = $('[data-cova-cta-compare]', root);
    var label = ctaLabel ? ctaLabel.getAttribute('data-label') || '' : '';
    if (ctaLabel && !label) {
      label = ctaLabel.textContent;
      ctaLabel.setAttribute('data-label', label);
    }

    function select(radio) {
      var index = radios.indexOf(radio);
      if (index < 0) return;
      var available = radio.getAttribute('data-available') !== 'false';
      cards.forEach(function (c, n) {
        c.classList.toggle('is-selected', n === index);
      });
      choices.forEach(function (c) {
        c.hidden = c.getAttribute('data-cova-offer-choice') !== String(index);
      });
      if (idInput) idInput.value = radio.getAttribute('data-variant-id') || radio.value;
      // Notify Shopify's native accelerated checkout when the bundle changes.
      if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (planInput) {
        var plan = radio.getAttribute('data-selling-plan') || '';
        planInput.value = plan;
        planInput.disabled = !plan;
      }
      if (ctaTotal) ctaTotal.textContent = radio.getAttribute('data-price') || '';
      if (ctaCompare) {
        var cmp = radio.getAttribute('data-compare') || '';
        ctaCompare.textContent = cmp;
        ctaCompare.hidden = !cmp;
      }
      if (cta) {
        cta.disabled = !available;
        if (ctaLabel) ctaLabel.textContent = available ? label : cta.getAttribute('data-sold-out-label') || label;
        if (ctaPrices) ctaPrices.hidden = !available;
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) select(r);
      });
    });
    var current = radios.filter(function (r) {
      return r.checked;
    })[0];
    if (current) select(current);

    // arrival date: today + N days, "October 16th"
    $$('[data-cova-ship-days]', root).forEach(function (el) {
      var days = parseInt(el.getAttribute('data-cova-ship-days'), 10);
      if (isNaN(days)) days = 7;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = formatDate(d);
    });

    // one submit per click; the browser then leaves for /checkout
    if (form && cta) {
      form.addEventListener('submit', function (e) {
        if (form.getAttribute('data-busy') === '1') {
          e.preventDefault();
          return;
        }
        form.setAttribute('data-busy', '1');
        cta.setAttribute('aria-busy', 'true');
      });
    }
  }

  function init(scope) {
    $$('[data-cova-offers]', scope || document).forEach(initOffers);
  }

  // back button after checkout: the page can come back from cache with the button still busy
  window.addEventListener('pageshow', function () {
    $$('[data-cova-offers] form').forEach(function (f) {
      f.removeAttribute('data-busy');
      var b = $('[data-cova-offers-cta]', f);
      if (b) b.removeAttribute('aria-busy');
    });
  });

  window.CovaOffers = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
